import { PropsWithChildren } from 'react';

export const ExternalLink = ({
  children,
  block,
  ...props
}: PropsWithChildren<JSX.IntrinsicElements['a'] & { block?: boolean }>) => (
  <a {...props}>{children}</a>
);
